import DeleteZone from "./DeleteZone";

export default DeleteZone